import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import { JOURNAL, JOURNAL_IMAGE_ALTS, resolveImage } from "../data/content";

export default function Journal({ entries }) {
  const list = Array.isArray(entries) && entries.length > 0 ? entries : JOURNAL;
  return (
    <section id="journal" data-testid="journal-section" className="scroll-mt-20 bg-forest py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">Journal</p>
        </Reveal>
        <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
          <Reveal delay={0.1}>
            <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
              Field notes <span className="italic text-brass">from the forest.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <Link
              to="/journal"
              data-testid="journal-view-all-link"
              className="text-xs tracking-[0.25em] text-brass transition-colors duration-300 hover:text-ivory"
            >
              READ ALL NOTES →
            </Link>
          </Reveal>
        </div>
        <div className="mt-14 grid gap-10 md:grid-cols-3">
          {list.map((j, i) => (
            <Reveal key={j.slug || j.title} delay={i * 0.12}>
              <Link
                to={`/journal/${j.slug}`}
                data-testid={`journal-card-${i}`}
                className="group block"
              >
                <div className="overflow-hidden">
                  <img
                    src={resolveImage(j.image, 800, 600)}
                    alt={j.imageAlt || JOURNAL_IMAGE_ALTS[j.slug] || `Photograph accompanying ${j.title}`}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <p className="mt-5 text-[11px] font-medium tracking-[0.3em] text-brass">
                  {(j.tag || "FIELD NOTES").toUpperCase()}
                </p>
                <h3 className="mt-3 font-serif text-2xl font-light leading-snug text-ivory transition-colors duration-500 group-hover:text-brass">
                  {j.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ivory/55">{j.excerpt || j.text}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
